<div class="d-flex udex-mt-24">
  <div class="d-flex flex-column justify-content-around">
    <span class="link-title heading__medium--xxxxs">
      {{('ctaForm.buttonText.' + slmTransactionType.code | cxTranslate)}}
    </span>
    <div class="body--xs">
      <span>
        {{('ctaForm.linkSubText.' + slmTransactionType.code + '.beginning' | cxTranslate)}}
      </span>
      <a
        [tabindex]="0"
        class="body--xs ds-color--blue ds-link ds-cursor--pointer focusable focusable__element"
        (click)="executeAction()">
          {{('ctaForm.linkSubText.' + slmTransactionType.code + '.link' | cxTranslate)}}
      </a>
      <span>
        {{('ctaForm.linkSubText.' + slmTransactionType.code + '.ending' | cxTranslate)}}
      </span>
    </div>
  </div>
